import { render, staticRenderFns } from "./apresentacao.vue?vue&type=template&id=d1eb96b6&lang=pug&"
import script from "./apresentacao.vue?vue&type=script&lang=js&"
export * from "./apresentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/marco/Documents/lsr/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VFooter } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VContainer,VContent,VFlex,VFooter,VLayout,VList,VListTile,VListTileContent})
